import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PromotionPhotoProfile, ReportPhotoProfile } from 'src/app/model/local/report.photo.profile';
import { Endpoints } from '../../environments/endpoints';
import { SpinnerNames } from '../constants/spinners';
import { CFDIListResponse } from '../model/http/cfdi.model';
import { BaseResponseHttp } from '../model/http/commons.model';
import { IGeneralResponse } from '../model/http/general-response.model';
import { GetReporterPhotoResponse } from '../model/http/get.reporter.photo';
import { IPaymentMethodRes } from '../model/http/paymentMethod.model';
import { DeliveredDirections, IDeliveredDirectionsRes, IGetComentsCardResponse,
  IGetMyProfileInfoResponse, IImagesReceiptPostRes, IImagesReceiptReq,
  IImagesReceiptRes, IMyProfileRes, IReceiptSttingsData, IResponsibleDoctorList,
  ITaxDataRes, IZipCodeResponse, RecipeAddress, RecipeSettingsData, ResponsibleDoctorsResponse,
  SaveLicense, SaveResponsibleDoctor, UpdateAddress, UpdateDataTax, IResponsibleDoctorInfo,
  SaveResponsibleDoctorLicense, ISignatureResponsibleDcotor,
  IGetAilmentsList,
} from '../model/http/profile.model';
import { IGetCalculateShippingCost } from '../model/http/shippingCost';
import {
  DefaultAddress, SaveProfileInfo,
  UpdateClinicInfo, UpdateProfilePhoto
} from '../model/local/general.model';
import { ReCreateTransactionRequest } from '../model/local/re-create-transaction';
import { ConsumeService } from './consume.service';
import { ResponsibleDoctorsResponseMock } from 'src/mocks/responsible.doctors.mock';
import { responsibleDoctorData } from 'src/mocks/responsableDoctorMock';
import { clinicInfoMock } from 'src/mocks/ailmentsListMock';
import { ICatalgosDermaRes } from '../model/http/catalogs';

@Injectable({
  providedIn: 'root',
})
export class MyProfileService {
  constructor(private consumeService: ConsumeService) { }
  getDirectionsDelivered(
    queryParams: string,
    spiner: SpinnerNames
  ): Observable<IDeliveredDirectionsRes> {
    return this.consumeService.httpGet<IDeliveredDirectionsRes>(
      `${Endpoints.profile.directionsDelivered}${queryParams}`, null, null, spiner
    );
  }
  getTaxData(queryParams: string): Observable<ITaxDataRes> {
    return this.consumeService.httpGet<ITaxDataRes>(
      `${Endpoints.profile.taxData}${queryParams}`, null, null, SpinnerNames.generalList
    );
  }
  getMyHeaderMyProfile(cardCode: string, clientType: string): Observable<IMyProfileRes> {
    return this.consumeService.httpGet<IMyProfileRes>(
      `${Endpoints.profile.myProfile}?cardCode=${cardCode}&clientType=${clientType}`
    );
  }
  getReciptSettings(queryParams: string): Observable<IReceiptSttingsData> {
    return this.consumeService.httpGet<IReceiptSttingsData>(
      `${Endpoints.profile.doctorInfo}${queryParams}`
    );
  }
  getResponsibleDoctorsList(queryParams: string): Observable<IResponsibleDoctorList> {
    return this.consumeService.httpGet<IResponsibleDoctorList>(`${Endpoints.profile.responsibleDoctorList}${queryParams}`);
  }

  getResponsibleDoctorInfo(doctorId: string): Observable<IResponsibleDoctorInfo> {
    return this.consumeService.httpGet<IResponsibleDoctorInfo>(`${Endpoints.profile.responsibleDoctorList}/${doctorId}/detail`);
  }

  saveReceiptSettings(
    doctorInformation: RecipeSettingsData
  ): Observable<IGeneralResponse> {
    return this.consumeService.httpPost<IGeneralResponse>(
      `${Endpoints.profile.saveDoctorInfo}`,
      doctorInformation
    );
  }
  getImagesReceipt(cardCode: string): Observable<IImagesReceiptRes> {
    return this.consumeService.httpGet<IImagesReceiptRes>(
      `${Endpoints.profile.imagesReceipt}?cardcode=${cardCode}`
    );
  }
  postImagesReceipt(
    imagesReceipt: IImagesReceiptReq
  ): Observable<IImagesReceiptPostRes> {
    return this.consumeService.httpPost<IImagesReceiptPostRes>(
      Endpoints.profile.imagesReceiptSave,
      imagesReceipt
    );
  }
  saveResponsibleDoctorSignature(signatureData: ISignatureResponsibleDcotor[]): Observable<IGeneralResponse> {
    return this.consumeService.httpPost<IGeneralResponse>(`${Endpoints.profile.responsibleDoctorList}/signature`, signatureData);
  }

  getZipCodeDetail(zipCode: string): Observable<IZipCodeResponse> {
    return this.consumeService.httpGet<IZipCodeResponse>(
      `${Endpoints.zipCode.detail}${zipCode}/locations`
    );
  }
  saveDirectionsDelivered(
    directionData: UpdateAddress,
  ): Observable<IGeneralResponse> {
    return this.consumeService.httpPost<IGeneralResponse>(
      `${Endpoints.profile.saveDirectionDelivery}`,
      directionData
    );
  }
  saveTaxData(
    taxData: UpdateDataTax
  ): Observable<IGeneralResponse> {
    return this.consumeService.httpPost<IGeneralResponse>(
      `${Endpoints.profile.saveTaxData}`,
      taxData,
    );
  }
  saveDefaultAddress(
    address: DefaultAddress
  ): Observable<IGeneralResponse> {
    return this.consumeService.httpPost<IGeneralResponse>(
      `${Endpoints.profile.defaultAddress}`,
      address
    );
  }
  updateProfilePhoto(
    updatePhoto: UpdateProfilePhoto
  ): Observable<IGeneralResponse> {
    return this.consumeService.httpPost(
      `${Endpoints.profile.updateProfilePhoto}`,
      updatePhoto
    );
  }

  saveProfileInfo(
    info: SaveProfileInfo
  ): Observable<IGeneralResponse> {
    return this.consumeService.httpPost(
      `${Endpoints.profile.saveMyProfileInfo}`,
      info
    );
  }
  getProfileInfo(cardCode: string): Observable<IGetMyProfileInfoResponse> {
    return this.consumeService.httpGet(
      `${Endpoints.profile.getMyProfileInfo}cardcode=${cardCode}`
    );
  }
  crudRecipeSettings(
    address: RecipeAddress
  ): Observable<IGeneralResponse> {
    return this.consumeService.httpPost<IGeneralResponse>(
      `${Endpoints.profile.crudRecipeAddress}`,
      address
    );
  }
  saveLicense(
    saveLicense: SaveLicense[]
  ): Observable<IGeneralResponse> {
    return this.consumeService.httpPost<IGeneralResponse>(
      `${Endpoints.profile.saveLicense}`,
      saveLicense
    );
  }
  saveNewLicense(saveLicense: SaveResponsibleDoctorLicense[]): Observable<IGeneralResponse> {
    return this.consumeService.httpPost<IGeneralResponse>(
      `${Endpoints.profile.saveResponsibleDoctor}/academicinfo`,
      saveLicense
    );
  }
  saveResponsibleDoctor(saveResponsibleDoctors: SaveResponsibleDoctor): Observable<IGeneralResponse> {
    return this.consumeService.httpPost<IGeneralResponse>(
      `${Endpoints.profile.saveResponsibleDoctor}`,
      saveResponsibleDoctors
    );
  }
  getComentsCard(cardCode: string): Observable<IGetComentsCardResponse> {
    return this.consumeService.httpGet(
      `${Endpoints.profile.getCommentsCard}cardcode=${cardCode}`
    );
  }
  saveClinicInfo(
    clinicInfo: UpdateClinicInfo
  ): Observable<IGeneralResponse> {
    return this.consumeService.httpPost(
      `${Endpoints.profile.saveClinicInfo}`,
      clinicInfo
    );
  }
  getCatalogDerma(): Observable<ICatalgosDermaRes> {
    return this.consumeService.httpGet<ICatalgosDermaRes>(
      Endpoints.catalogs.listDerma
    );
  }
  getCalculateshippingcost(
    queryParams: string
  ): Observable<IGetCalculateShippingCost> {
    return this.consumeService.httpGet(
      `${Endpoints.profile.shippingcost}${queryParams}`
    );
  }

  saveReporterPhotoProfile(
    data: ReportPhotoProfile
  ): Observable<IGeneralResponse> {
    return this.consumeService.httpPost(
      `${Endpoints.profile.saveReporter}`,
      data
    );
  }

  getReporterPhotoProfile(
    username: string
  ): Observable<GetReporterPhotoResponse> {
    return this.consumeService.httpGet(
      `${Endpoints.profile.getReporterPhoto}/${username}/profilepicture`
    );
  }

  getPromotionsPhotoProfile(username: string): Observable<GetReporterPhotoResponse> {
    return this.consumeService.httpGet(
      `${Endpoints.promotionCodes.getAdminPhoto}/${username}/profilepicture`
    );
  }

  reCreateTransaction(
    request: ReCreateTransactionRequest
  ): Observable<IPaymentMethodRes> {
    return this.consumeService.httpPost(
      `${Endpoints.profile.reCreateTransaction}`,
      request
    );
  }

  getCFDIList(): Observable<CFDIListResponse> {
    return this.consumeService.httpGet(`${Endpoints.cfdiList}`);
  }

  changePromoProfilePhoto(req: PromotionPhotoProfile): Observable<BaseResponseHttp> {
    return this.consumeService.httpPost(Endpoints.promotionCodes.savePromotionProfilePhoto, req);
  }

  deleteResponsibleDoctor(id: number): Observable<BaseResponseHttp> {
    return this.consumeService.httpDelete(`${Endpoints.profile.deleteResponsibleDoctor}/${id}`);
  }

  getResponsibleDoctors(params: string): Observable<ResponsibleDoctorsResponse> {
    return this.consumeService.httpGet(`${Endpoints.profile.getResponsibleDoctors}?${params}`);
  }
}
